import { render, staticRenderFns } from "./DisableGroupByDisputeModal.vue?vue&type=template&id=2b3ba7ec&scoped=true&"
import script from "./DisableGroupByDisputeModal.vue?vue&type=script&lang=js&"
export * from "./DisableGroupByDisputeModal.vue?vue&type=script&lang=js&"
import style0 from "./DisableGroupByDisputeModal.vue?vue&type=style&index=0&id=2b3ba7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ba7ec",
  null
  
)

export default component.exports